import ApiService from '@/services/core/api.service'

const AdminCustomerService = {
  async get (query) {
    return ApiService.get(`admin/customers?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/units', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/units/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`admin/units/${payload.id}`)
  }
}

export default AdminCustomerService
